require('./bootstrap');
window.helper = require( "../helper/helper" );
window.helper = window.helper.run()
window.formHelper = require( "../helper/forms" );
window.formHelper = window.formHelper.run()
window.base = require( "./base" );
window.base = window.base.run();
window.user = require( "./user" );
window.property = require( "./properties" );
window.user_property = require( "./user_property" );
window.sortable = require('../helper/sortable');